import { render, staticRenderFns } from "./AssumptionsResidentialNew.vue?vue&type=template&id=cfc3bfd0&scoped=true&"
import script from "./AssumptionsResidentialNew.vue?vue&type=script&lang=js&"
export * from "./AssumptionsResidentialNew.vue?vue&type=script&lang=js&"
import style0 from "./AssumptionsResidentialNew.vue?vue&type=style&index=0&id=cfc3bfd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfc3bfd0",
  null
  
)

export default component.exports